import * as React from 'react';
import type {
  Filters,
  PaginationControl,
} from 'hooks/store/invoices/use-invoices-tracking-search-params';
import type { Invoice } from 'contracts/tracking-v2/invoices';
import type { Pagination } from 'contracts/Pagination';
import { api, applyQueryString, handleApiError } from 'services/api';

type Payload = {
  filters?: Filters;
  eligibleForTripCreation?: boolean;
  pagination?: PaginationControl
}

type Response = {
  data: Invoice[];
  meta: Pagination;
}


export const useFetchPaginatedInvoices = () => {
  const fetchPaginatedInvoices = React.useCallback(async (payload: Payload) => {
    const url = applyQueryString('/tracking-v2/invoices', {
      ...(payload?.eligibleForTripCreation && {
        eligibleForTripCreation: true,
      }),
      ...payload.filters,
      ...payload.pagination,
    });

    try {
      const { data } = await api.get<Response>(url);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    fetchPaginatedInvoices,
  };
};